import { Controller } from "@hotwired/stimulus"

// LV import, step "Prüfung": "Preise übernehmen als" only applies when the import also
// yields an Angebot or Rechnung, and the Zuschlagsprofil only to purchase prices.
// The server ignores both for a plain LV import, so hiding is presentation only.
export default class extends Controller {
  static targets = ["importTarget", "priceMode", "priceModeOption", "profile"]

  connect() {
    this.update()
  }

  update() {
    const billing = ["offer", "invoice"].includes(this.checkedValue(this.importTargetTargets))
    const purchase = this.checkedValue(this.priceModeOptionTargets) === "purchase"

    if (this.hasPriceModeTarget) this.priceModeTarget.classList.toggle("hidden", !billing)
    if (this.hasProfileTarget) this.profileTarget.classList.toggle("hidden", !(billing && purchase))
  }

  checkedValue(inputs) {
    return inputs.find((input) => input.checked)?.value
  }
}
